var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g = Object.create((typeof Iterator === "function" ? Iterator : Object).prototype);
    return g.next = verb(0), g["throw"] = verb(1), g["return"] = verb(2), typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (g && (g = 0, op[0] && (_ = 0)), _) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
var __spreadArray = (this && this.__spreadArray) || function (to, from, pack) {
    if (pack || arguments.length === 2) for (var i = 0, l = from.length, ar; i < l; i++) {
        if (ar || !(i in from)) {
            if (!ar) ar = Array.prototype.slice.call(from, 0, i);
            ar[i] = from[i];
        }
    }
    return to.concat(ar || Array.prototype.slice.call(from));
};
import { jsx as _jsx, Fragment as _Fragment, jsxs as _jsxs } from "react/jsx-runtime";
import React, { useState, useMemo, useCallback, useContext, useRef, useEffect } from 'react';
import '../styles/inputWithBtn.scss';
import { useTranslation } from 'react-i18next';
import CollapsibleSection from './CollapsibleSection';
import CustomScrollbar from './CustomScrollbar';
import ButtonComponent from './ButtonComponent';
import Popup from './Popup';
import SaveWorkModal from './SaveWorkModal';
import ViewCodeModal from './ViewCodeModal';
import { getImageSrc } from '../helper/imageBlobCache';
import { formatShareCode, normalizeShareCode } from '../helper/shareCode';
import { rememberOwnShareCode } from '../helper/ownShareCodes';
import { API_BASE_URL } from '../config/api';
import customEventHandler from '../helper/customEvents';
import { extractUserSaveState } from '../middleware/jsonMiddleware';
import { postShareCodeSave } from '../helper/saveShareCode';
import { trackEvent, AnalyticsCategory } from '../helper/analytics';
import { copyTextToClipboard } from '../helper/clipboardHelper';
import globalStore from '../store';
import { withBusy } from '../helper/busyOverlay';
import { DataContext } from '../player/DataContext';
var entryIdCounter = 0;
var generateEntryId = function () { return "entry_".concat(Date.now(), "_").concat(entryIdCounter++); };
var ICON_SIZE = 19;
// localStorage key for the expand/collapse state of the folders panel.
// Persists across reloads so the user's panel layout sticks.
var EXPANDED_SECTIONS_STORAGE_KEY = 'iwb.expandedSectionIds';
var loadExpandedSectionIds = function () {
    try {
        var raw = window.localStorage.getItem(EXPANDED_SECTIONS_STORAGE_KEY);
        if (!raw)
            return new Set();
        var parsed = JSON.parse(raw);
        return Array.isArray(parsed)
            ? new Set(parsed.filter(function (x) { return typeof x === 'string'; }))
            : new Set();
    }
    catch (_a) {
        return new Set();
    }
};
var saveExpandedSectionIds = function (ids) {
    try {
        window.localStorage.setItem(EXPANDED_SECTIONS_STORAGE_KEY, JSON.stringify(Array.from(ids)));
    }
    catch (_a) {
        // localStorage may be unavailable (private mode, quota); ignore.
    }
};
/** Deep-clone helper for sections */
var cloneSections = function (sections) { return JSON.parse(JSON.stringify(sections)); };
/** Find and update a section by id anywhere in the tree */
var updateSectionInTree = function (sections, id, updater) {
    var result = [];
    for (var _i = 0, sections_1 = sections; _i < sections_1.length; _i++) {
        var section = sections_1[_i];
        if (section.id === id) {
            var updated = updater(section);
            if (updated)
                result.push(updated);
        }
        else {
            var copy = __assign({}, section);
            if (copy.children) {
                copy.children = updateSectionInTree(copy.children, id, updater);
            }
            result.push(copy);
        }
    }
    return result;
};
/** Find an entry by normalized share code across all sections, returns the entry or null */
var findEntryByCode = function (sections, code) {
    var target = normalizeShareCode(code);
    if (!target)
        return null;
    for (var _i = 0, sections_2 = sections; _i < sections_2.length; _i++) {
        var section = sections_2[_i];
        if (section.entries) {
            var entry = section.entries.find(function (e) { return normalizeShareCode(e.code) === target; });
            if (entry)
                return entry;
        }
        if (section.children) {
            var found = findEntryByCode(section.children, code);
            if (found)
                return found;
        }
    }
    return null;
};
/** Find an entry by id across all sections, returns the entry or null */
var findEntryById = function (sections, entryId) {
    for (var _i = 0, sections_3 = sections; _i < sections_3.length; _i++) {
        var section = sections_3[_i];
        if (section.entries) {
            var entry = section.entries.find(function (e) { return e.id === entryId; });
            if (entry)
                return entry;
        }
        if (section.children) {
            var found = findEntryById(section.children, entryId);
            if (found)
                return found;
        }
    }
    return null;
};
// Entry sort key for "Sort by Name": the label, falling back to the share
// code when the entry is unlabeled. Without the fallback, the Uncategorized
// (`ungrouped`) section — which holds unlabeled saves — has all-empty labels,
// so a label-only comparator never reorders it and the sort looks broken.
var entryNameKey = function (e) { var _a; return e.label && e.label.trim() ? e.label.trim() : ((_a = e.code) !== null && _a !== void 0 ? _a : ''); };
var compareEntriesByName = function (a, b) {
    return entryNameKey(a).localeCompare(entryNameKey(b));
};
var entryTs = function (v) { return (v ? new Date(v).getTime() : 0); };
var compareEntriesByModified = function (a, b) {
    return entryTs(b.updatedAt) - entryTs(a.updatedAt);
};
var InputWithBtn = function (props) {
    var _a, _b, _c, _d, _e, _f, _g, _h, _j, _k;
    var t = useTranslation().t;
    var style = props.style, sectionsProp = props.sections, onSave = props.onSave, onDuplicate = props.onDuplicate, onShare = props.onShare, onSectionsChange = props.onSectionsChange, _l = props.arrowPosition, arrowPosition = _l === void 0 ? 'top' : _l;
    var btnConfig = globalStore.useStoreState(function (state) { return state.jsonDataStore; }).btnConfig;
    var _m = globalStore.useStoreState(function (state) { return state.playerStore; }), shareCode = _m.shareCode, isLoggedIn = _m.isLoggedIn, pageData = _m.pageData, productionBaseline = _m.productionBaseline, activityMeta = _m.activityMeta, isIDM = _m.isIDM, isSwp = _m.isSwp, username = _m.username, currentPage = _m.currentPage, isAdmin = _m.isAdmin, playerBgPattern = _m.playerBgPattern, zoomLevel = _m.zoomLevel;
    var pdfExists = pageData.some(function (page) { var _a; return /\.pdf(\?|$)/i.test((_a = page === null || page === void 0 ? void 0 : page.background) !== null && _a !== void 0 ? _a : ''); });
    // Live state for the page the user is currently on. The eager pageData
    // sync was removed to fix next/back contamination, so we now merge the
    // live DataContext state into pageData at save time — current page from
    // here, every other page from the playerStore snapshot.
    var _o = useContext(DataContext), manipulative = _o.manipulative, text = _o.text, table = _o.table, annotations = _o.annotations, shades = _o.shades, drawCommands = _o.drawCommands, 
    // manipulativeBtnState,
    // Drives the standalone IwbSharePopup component (mounted at app level
    // by PlayerMainContainer). Replaces the previous local useState so the
    // popup can be opened from outside this component (e.g. the
    // Cmd/Ctrl+Alt+S keyboard shortcut).
    showIwbSharePopup = _o.showIwbSharePopup, setShowIwbSharePopup = _o.setShowIwbSharePopup, manipulativeBtnState = _o.manipulativeBtnState, coinsAndCountersDrawer = _o.coinsAndCountersDrawer;
    var buildMergedPageData = useCallback(function () {
        var liveCurrent = {
            widgets: manipulative,
            text: text,
            table: table,
            annotations: annotations,
            shades: shades,
            drawCommands: drawCommands,
            zoomLevel: zoomLevel,
            coinsAndCountersDrawer: coinsAndCountersDrawer,
        };
        var idx = Math.max(0, currentPage - 1);
        // `pageData` is empty for fresh non-IDM activities — `loadActivityData`
        // early-returns when there's no IDM context and no share code, so the
        // pagesData array is never built. A naive `pageData.map(...)` would
        // then produce `[]` and the save payload would land with empty
        // `workspaces`, dropping anything the user dropped on the canvas. Pad
        // the array up to the current page index so the live state still
        // surfaces in `workspaces[idx]`.
        if (idx >= pageData.length) {
            var emptyPage = {
                widgets: [],
                text: [],
                table: [],
                annotations: [],
                shades: [],
                drawCommands: [],
                coinsAndCountersDrawer: [],
            };
            var padded = __spreadArray([], pageData, true);
            while (padded.length <= idx)
                padded.push(__assign({}, emptyPage));
            padded[idx] = __assign(__assign({}, padded[idx]), liveCurrent);
            return padded;
        }
        return pageData.map(function (page, i) { return (i === idx ? __assign(__assign({}, page), liveCurrent) : page); });
    }, [
        pageData,
        currentPage,
        manipulative,
        text,
        table,
        annotations,
        shades,
        drawCommands,
        zoomLevel,
        coinsAndCountersDrawer,
    ]);
    var _p = globalStore.useStoreState(function (state) { return state.groupsStore; }), storeSections = _p.sections, groupsLoaded = _p.loaded;
    var _q = globalStore.useStoreActions(function (state) { return state.groupsStore; }), fetchGroups = _q.fetchGroups, setStoreSections = _q.setSections;
    var setShareCode = globalStore.useStoreActions(function (state) { return state.playerStore; }).setShareCode;
    // Lazy-fetch groups the first time this panel opens.
    useEffect(function () {
        if (!groupsLoaded)
            fetchGroups();
    }, [groupsLoaded, fetchGroups]);
    // Prop > store. When a caller explicitly passes sections, that wins; otherwise
    // the store is the source of truth so refetches propagate automatically.
    var _r = useState(sectionsProp !== null && sectionsProp !== void 0 ? sectionsProp : storeSections), localSections = _r[0], setLocalSections = _r[1];
    useEffect(function () {
        if (sectionsProp)
            return;
        setLocalSections(storeSections);
    }, [storeSections, sectionsProp]);
    var _s = useState(new Set()), selectedEntries = _s[0], setSelectedEntries = _s[1];
    var _t = useState(false), showSettings = _t[0], setShowSettings = _t[1];
    // Active sort applied via the settings popup. Real sections are sorted in
    // place (localSections), but the synthetic Favourites pseudo-section is
    // rebuilt from localSections on every render, so it must re-apply the sort
    // here to stay ordered alongside the rest.
    var _u = useState(null), sortMode = _u[0], setSortMode = _u[1];
    var settingsRef = useRef(null);
    var _v = useState(loadExpandedSectionIds), expandedSectionIds = _v[0], setExpandedSectionIds = _v[1];
    var _w = useState(null), renameModal = _w[0], setRenameModal = _w[1];
    var _x = useState(''), renameValue = _x[0], setRenameValue = _x[1];
    var _y = useState(null), removeSectionId = _y[0], setRemoveSectionId = _y[1];
    // Two-step delete: first show a confirmation popup, then on confirm fire
    // the API calls and surface a "deleted successfully" popup.
    var _z = useState(false), showDeleteConfirm = _z[0], setShowDeleteConfirm = _z[1];
    var _0 = useState(false), showDeleteSuccess = _0[0], setShowDeleteSuccess = _0[1];
    var _1 = useState(false), showSaveInfoModal = _1[0], setShowSaveInfoModal = _1[1];
    var _2 = useState(false), showSaveErrorModal = _2[0], setShowSaveErrorModal = _2[1];
    var _3 = useState(false), showApiErrorModal = _3[0], setShowApiErrorModal = _3[1];
    // Copy-to-clipboard state and helper, plus the share-link URL helper, all
    // moved to IwbSharePopup.tsx along with the popup body that uses them.
    var _4 = useState(false), isSaving = _4[0], setIsSaving = _4[1];
    var _5 = useState(false), showDuplicateModal = _5[0], setShowDuplicateModal = _5[1];
    // When the Save button opens the duplicate modal (no share code yet, non-
    // IDM activity), retitle the popup so the user understands they're naming
    // the *first* save rather than duplicating an existing one.
    var _6 = useState(false), saveAsNewActivity = _6[0], setSaveAsNewActivity = _6[1];
    // When the Save button is clicked on an existing share code that has no label
    // yet (e.g. a freshly-created, empty code), open the same modal to name it —
    // titled "Save this Activity" — but save in place under the existing code
    // instead of generating a new one.
    var _7 = useState(false), saveExistingUnlabeled = _7[0], setSaveExistingUnlabeled = _7[1];
    var _8 = useState(false), showMoveToModal = _8[0], setShowMoveToModal = _8[1];
    var _9 = useState(false), addingFolder = _9[0], setAddingFolder = _9[1];
    var _10 = useState(''), newFolderName = _10[0], setNewFolderName = _10[1];
    var newFolderInputRef = useRef(null);
    // Guest-mode (logged-out) "Generate Code" flow.
    var _11 = useState(''), guestGeneratedCode = _11[0], setGuestGeneratedCode = _11[1];
    var _12 = useState(false), guestGenerating = _12[0], setGuestGenerating = _12[1];
    var _13 = useState(false), guestShowDisplayCode = _13[0], setGuestShowDisplayCode = _13[1];
    var _14 = useState(null), guestCopyFeedback = _14[0], setGuestCopyFeedback = _14[1];
    var _15 = useState(null), guestImageFeedback = _15[0], setGuestImageFeedback = _15[1];
    var _16 = useState(null), guestCodeGenFeedback = _16[0], setGuestCodeGenFeedback = _16[1];
    // Logged-in "Display Code" — opened from the settings popup. Reuses the
    // ViewCodeModal so the visual is identical to the guest flow.
    var _17 = useState(false), showDisplayCodeModal = _17[0], setShowDisplayCodeModal = _17[1];
    // Use the existing share code from the player store — no fresh generation.
    // Share action is disabled when there's nothing to share.
    var hasShareCode = !!shareCode;
    // `shareCodeValue` and `shareLinkUrl` moved to IwbSharePopup.tsx with the
    // popup body that uses them.
    var renameInputRef = useRef(null);
    var guestPanelRef = useRef(null);
    // Auto-focus first button and focus trap for the guest panel
    useEffect(function () {
        var _a;
        if (isLoggedIn)
            return;
        var firstFocusable = (_a = guestPanelRef.current) === null || _a === void 0 ? void 0 : _a.querySelector('button:not([disabled]), input:not([disabled])');
        firstFocusable === null || firstFocusable === void 0 ? void 0 : firstFocusable.focus();
        var handleKeyDown = function (e) {
            var _a;
            if (e.key !== 'Tab' || !guestPanelRef.current)
                return;
            var focusables = Array.from(guestPanelRef.current.querySelectorAll('button:not([disabled]):not([aria-hidden="true"]), input:not([disabled]), [tabindex]:not([tabindex="-1"])')).filter(function (el) { return el.offsetParent !== null; });
            if (focusables.length === 0)
                return;
            e.preventDefault();
            var currentIndex = focusables.indexOf(document.activeElement);
            var nextIndex = e.shiftKey
                ? currentIndex <= 0 ? focusables.length - 1 : currentIndex - 1
                : currentIndex >= focusables.length - 1 ? 0 : currentIndex + 1;
            (_a = focusables[nextIndex]) === null || _a === void 0 ? void 0 : _a.focus();
        };
        document.addEventListener('keydown', handleKeyDown, true);
        return function () { return document.removeEventListener('keydown', handleKeyDown, true); };
    }, [isLoggedIn]);
    useEffect(function () {
        if (renameModal && renameInputRef.current) {
            renameInputRef.current.focus();
            renameInputRef.current.select();
        }
    }, [renameModal]);
    var setSections = useCallback(function (next) {
        setLocalSections(next);
        if (!sectionsProp)
            setStoreSections(next);
        onSectionsChange === null || onSectionsChange === void 0 ? void 0 : onSectionsChange(next);
    }, [onSectionsChange, sectionsProp, setStoreSections]);
    var handleCheckToggle = useCallback(function (entryId) {
        setSelectedEntries(function (prev) {
            var next = new Set(prev);
            if (next.has(entryId)) {
                next.delete(entryId);
            }
            else {
                next.add(entryId);
            }
            return next;
        });
    }, []);
    // Normalized form (uppercase alphanumerics, no separator) so that
    // '3J2L-B5EB' / '3j2lb5eb' / '3J2L B5EB' all compare equal.
    var normalizedShareCode = useMemo(function () { return normalizeShareCode(shareCode); }, [shareCode]);
    // Stamp entries with a derived isCurrentBuild (entry.code matches the active shareCode).
    var stampCurrentBuild = useCallback(function (entries) {
        return entries === null || entries === void 0 ? void 0 : entries.map(function (entry) {
            var normalizedCode = normalizeShareCode(entry.code);
            var isCurrentBuild = !!normalizedShareCode && normalizedCode === normalizedShareCode;
            return isCurrentBuild === !!entry.isCurrentBuild ? entry : __assign(__assign({}, entry), { isCurrentBuild: isCurrentBuild });
        });
    }, [normalizedShareCode]);
    // ── Favourites section (computed, read-only) ──
    var sectionsWithFavourites = useMemo(function () {
        var decorateTree = function (sections) {
            return sections.map(function (section) { return (__assign(__assign({}, section), { entries: stampCurrentBuild(section.entries), children: section.children ? decorateTree(section.children) : undefined })); });
        };
        var decorated = decorateTree(localSections);
        var favEntries = [];
        decorated.forEach(function (section) {
            var _a;
            (_a = section.entries) === null || _a === void 0 ? void 0 : _a.forEach(function (entry) {
                if (entry.isFavourite) {
                    favEntries.push(entry);
                }
            });
        });
        if (favEntries.length === 0)
            return decorated;
        // Favourites is rebuilt here on every render (it isn't part of the sorted
        // localSections tree), so re-apply whatever sort is active — otherwise
        // "Sort by Name" visibly reorders every real folder but leaves Favourites
        // in collection order.
        if (sortMode === 'name')
            favEntries.sort(compareEntriesByName);
        else if (sortMode === 'modified')
            favEntries.sort(compareEntriesByModified);
        var favSection = {
            id: 'favourites',
            titleKey: 'text.favourites',
            entries: favEntries,
        };
        return __spreadArray([favSection], decorated, true);
    }, [localSections, stampCurrentBuild, sortMode]);
    var hasSelection = selectedEntries.size > 0;
    // Flat id→isFavourite map, recomputed only when localSections changes.
    var entryFavouriteMap = useMemo(function () {
        var map = new Map();
        var visit = function (sections) {
            sections.forEach(function (s) {
                var _a;
                (_a = s.entries) === null || _a === void 0 ? void 0 : _a.forEach(function (e) { return map.set(e.id, !!e.isFavourite); });
                if (s.children)
                    visit(s.children);
            });
        };
        visit(localSections);
        return map;
    }, [localSections]);
    var allSelectedAreFavourites = useMemo(function () {
        if (!hasSelection)
            return false;
        return Array.from(selectedEntries).every(function (id) { return entryFavouriteMap.get(id) === true; });
    }, [hasSelection, selectedEntries, entryFavouriteMap]);
    // ── Section operations (context menu) ──
    var handleRenameSection = useCallback(function (sectionId) {
        // Find current name for the input placeholder
        var findName = function (sections) {
            for (var _i = 0, sections_4 = sections; _i < sections_4.length; _i++) {
                var s = sections_4[_i];
                if (s.id === sectionId)
                    return s.titleKey.startsWith('text.') ? t(s.titleKey) : s.titleKey;
                if (s.children) {
                    var found = findName(s.children);
                    if (found)
                        return found;
                }
            }
            return '';
        };
        var currentName = findName(localSections);
        setRenameValue(currentName);
        setRenameModal({ sectionId: sectionId, currentName: currentName });
    }, [localSections]);
    var confirmRename = useCallback(function () {
        if (!renameModal || !renameValue.trim())
            return;
        // Server is source of truth: PUT /groups/{id}, then re-fetch groups so
        // the renamed folder reflects the backend's authoritative state.
        var sectionId = renameModal.sectionId;
        var trimmed = renameValue.trim();
        setRenameModal(null);
        setRenameValue('');
        withBusy(function () { return __awaiter(void 0, void 0, void 0, function () {
            var res;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0: return [4 /*yield*/, fetch("".concat(API_BASE_URL, "groups/").concat(encodeURIComponent(sectionId)), {
                            method: 'PUT',
                            credentials: 'include',
                            headers: { 'Content-Type': 'application/json' },
                            body: JSON.stringify({ name: trimmed }),
                        }).catch(function () { return null; })];
                    case 1:
                        res = _a.sent();
                        if (!(res === null || res === void 0 ? void 0 : res.ok)) {
                            setShowApiErrorModal(true);
                            return [2 /*return*/];
                        }
                        return [4 /*yield*/, fetchGroups()];
                    case 2:
                        _a.sent();
                        return [2 /*return*/];
                }
            });
        }); });
    }, [renameModal, renameValue, fetchGroups]);
    var handleRemoveSection = useCallback(function (sectionId) {
        setRemoveSectionId(sectionId);
    }, []);
    var confirmRemoveSection = useCallback(function () {
        if (!removeSectionId)
            return;
        // Server is source of truth: DELETE /groups/{id}, then re-fetch groups
        // so the section disappears with whatever the backend reports.
        var sectionId = removeSectionId;
        setSelectedEntries(new Set());
        setRemoveSectionId(null);
        withBusy(function () { return __awaiter(void 0, void 0, void 0, function () {
            var res;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0: return [4 /*yield*/, fetch("".concat(API_BASE_URL, "groups/").concat(encodeURIComponent(sectionId)), {
                            method: 'DELETE',
                            credentials: 'include',
                        }).catch(function () { return null; })];
                    case 1:
                        res = _a.sent();
                        if (!(res === null || res === void 0 ? void 0 : res.ok)) {
                            setShowApiErrorModal(true);
                            return [2 /*return*/];
                        }
                        return [4 /*yield*/, fetchGroups()];
                    case 2:
                        _a.sent();
                        return [2 /*return*/];
                }
            });
        }); });
    }, [removeSectionId, fetchGroups]);
    // Sort by Name: sort folders alphabetically by their displayed title, and
    // sort each folder's entries alphabetically by label. Recurses through
    // children. The synthetic "favourites" pseudo-section is layered later in
    // `sectionsWithFavourites` so it isn't part of the sort.
    var handleSortByName = useCallback(function () {
        var sortTree = function (sections) {
            var sorted = __spreadArray([], sections, true).sort(function (a, b) {
                var at = a.titleKey.startsWith('text.') ? t(a.titleKey) : a.titleKey;
                var bt = b.titleKey.startsWith('text.') ? t(b.titleKey) : b.titleKey;
                return at.localeCompare(bt);
            });
            return sorted.map(function (section) { return (__assign(__assign({}, section), { 
                // Sort by label, falling back to code so unlabeled entries (the whole
                // Uncategorized section) still get an alphabetical order instead of
                // staying put.
                entries: section.entries
                    ? __spreadArray([], section.entries, true).sort(compareEntriesByName)
                    : section.entries, children: section.children ? sortTree(section.children) : section.children })); });
        };
        setSortMode('name');
        setSections(sortTree(cloneSections(localSections)));
        setSelectedEntries(new Set());
    }, [localSections, setSections]);
    // Sort by Modified — most-recently-updated first. Sections without an
    // `updatedAt` (e.g. the synthetic favourites pseudo-section, or the
    // backend's `ungrouped` placeholder) sort last. Recurses into children.
    var handleSortByModified = useCallback(function () {
        var sortTree = function (sections) {
            var sorted = __spreadArray([], sections, true).sort(function (a, b) { return entryTs(b.updatedAt) - entryTs(a.updatedAt); });
            return sorted.map(function (section) { return (__assign(__assign({}, section), { entries: section.entries
                    ? __spreadArray([], section.entries, true).sort(compareEntriesByModified)
                    : section.entries, children: section.children ? sortTree(section.children) : section.children })); });
        };
        setSortMode('modified');
        setSections(sortTree(cloneSections(localSections)));
        setSelectedEntries(new Set());
    }, [localSections, setSections]);
    // ── Footer operations (act on selected entry IDs) ──
    var handleToggleFavourite = useCallback(function (entryId) {
        // Two entry points:
        //   1. Per-row star (iwb-favBtn) passes the entry id directly — toggle
        //      that single share-code, regardless of whether anything is
        //      checked.
        //   2. (Reserved) bulk toggle from a future footer button could call
        //      with no args and fall through to the checkbox selection.
        var targetIds = entryId ? [entryId] : Array.from(selectedEntries);
        if (targetIds.length === 0)
            return;
        if (!entryId)
            setSelectedEntries(new Set());
        // Server is source of truth: PATCH each share-code, then re-fetch
        // groups so the favourite flag reflects whatever the backend applied.
        withBusy(function () { return __awaiter(void 0, void 0, void 0, function () {
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0: return [4 /*yield*/, Promise.all(targetIds.map(function (id) {
                            return fetch("".concat(API_BASE_URL, "share-codes/").concat(encodeURIComponent(id), "/favourite"), {
                                method: 'PATCH',
                                credentials: 'include',
                                headers: { 'Content-Type': 'application/json' },
                            }).catch(function () { return undefined; });
                        }))];
                    case 1:
                        _a.sent();
                        return [4 /*yield*/, fetchGroups()];
                    case 2:
                        _a.sent();
                        return [2 /*return*/];
                }
            });
        }); });
    }, [selectedEntries, fetchGroups]);
    // Step 1 of delete: just open the confirmation popup. The actual API call
    // happens in `confirmDeleteEntries` after the user clicks Delete.
    var handleDeleteEntries = useCallback(function () {
        if (!hasSelection)
            return;
        setShowDeleteConfirm(true);
    }, [hasSelection]);
    // Step 2 of delete: fire the DELETE calls, then surface the success popup.
    // If the active share code was in the batch, redirect to "/" once the
    // success popup is dismissed (handled by the popup's onClose).
    var confirmDeleteEntries = useCallback(function () {
        setShowDeleteConfirm(false);
        if (!hasSelection)
            return;
        // The DELETE endpoint keys off the share code itself (e.g.
        // `share-codes/3J2L-B5EB`), not the row id, so collect the codes from the
        // live tree. Favourites is a synthetic section (not in `localSections`),
        // so it's already excluded by walking only the real tree.
        var codes = [];
        var collect = function (sections) {
            var _a;
            for (var _i = 0, sections_5 = sections; _i < sections_5.length; _i++) {
                var section = sections_5[_i];
                (_a = section.entries) === null || _a === void 0 ? void 0 : _a.forEach(function (entry) {
                    if (selectedEntries.has(entry.id) && entry.code) {
                        codes.push(entry.code);
                    }
                });
                if (section.children)
                    collect(section.children);
            }
        };
        collect(localSections);
        // If the user just deleted the share code that's loaded in the URL, the
        // browser tab is now pointing at a code that no longer exists. Defer the
        // redirect until the success popup is dismissed (see onClose below).
        var activeCode = normalizeShareCode(shareCode);
        var deletingActive = !!activeCode && codes.some(function (c) { return normalizeShareCode(c) === activeCode; });
        setSelectedEntries(new Set());
        withBusy(function () { return __awaiter(void 0, void 0, void 0, function () {
            var results;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0: return [4 /*yield*/, Promise.all(codes.map(function (code) {
                            return fetch("".concat(API_BASE_URL, "share-codes/").concat(encodeURIComponent(code)), {
                                method: 'DELETE',
                                credentials: 'include',
                            }).catch(function () { return null; });
                        }))];
                    case 1:
                        results = _a.sent();
                        if (results.some(function (r) { return !(r === null || r === void 0 ? void 0 : r.ok); })) {
                            setShowApiErrorModal(true);
                            return [2 /*return*/];
                        }
                        if (!!deletingActive) return [3 /*break*/, 3];
                        return [4 /*yield*/, fetchGroups()];
                    case 2:
                        _a.sent();
                        _a.label = 3;
                    case 3:
                        // Stash the redirect intent on the window so the success popup's
                        // onClose can act on it without a separate state field.
                        window.__iwbDeleteRedirect = deletingActive;
                        setShowDeleteSuccess(true);
                        return [2 /*return*/];
                }
            });
        }); });
    }, [hasSelection, selectedEntries, localSections, fetchGroups, shareCode]);
    var handleMoveTo = useCallback(function (targetSectionId) {
        if (!hasSelection)
            return;
        // Server is source of truth: PUT each selected share-code into the
        // target group, then re-fetch groups so the list reflects whatever
        // the backend actually accepted.
        var movedIds = Array.from(selectedEntries);
        setSelectedEntries(new Set());
        setShowMoveToModal(false);
        withBusy(function () { return __awaiter(void 0, void 0, void 0, function () {
            var results;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0: return [4 /*yield*/, Promise.all(movedIds.map(function (shareCodeId) {
                            return fetch("".concat(API_BASE_URL, "groups/").concat(encodeURIComponent(targetSectionId), "/share-codes/").concat(encodeURIComponent(shareCodeId)), {
                                method: 'POST',
                                credentials: 'include',
                                headers: { 'Content-Type': 'application/json' },
                            }).catch(function () { return null; });
                        }))];
                    case 1:
                        results = _a.sent();
                        if (results.some(function (r) { return !(r === null || r === void 0 ? void 0 : r.ok); })) {
                            setShowApiErrorModal(true);
                            return [2 /*return*/];
                        }
                        return [4 /*yield*/, fetchGroups()];
                    case 2:
                        _a.sent();
                        return [2 /*return*/];
                }
            });
        }); });
    }, [hasSelection, selectedEntries, fetchGroups]);
    var handleDuplicateEntries = useCallback(function () {
        if (!hasSelection)
            return;
        var duplicateInSections = function (sections) {
            return sections.map(function (section) {
                var _a;
                var newEntries = [];
                (_a = section.entries) === null || _a === void 0 ? void 0 : _a.forEach(function (entry) {
                    newEntries.push(entry);
                    if (selectedEntries.has(entry.id)) {
                        newEntries.push(__assign(__assign({}, entry), { id: generateEntryId() }));
                    }
                });
                return __assign(__assign({}, section), { entries: newEntries, children: section.children ? duplicateInSections(section.children) : undefined });
            });
        };
        setSections(duplicateInSections(cloneSections(localSections)));
        setSelectedEntries(new Set());
    }, [hasSelection, selectedEntries, localSections, setSections]);
    // The section containing a selected entry — null when nothing is selected.
    // Rename/Remove require this; Sort falls back to the last expanded section.
    var selectedSectionId = useMemo(function () {
        if (selectedEntries.size === 0)
            return null;
        var firstSelectedId = Array.from(selectedEntries)[0];
        var findSection = function (sections) {
            var _a;
            for (var _i = 0, sections_6 = sections; _i < sections_6.length; _i++) {
                var section = sections_6[_i];
                if ((_a = section.entries) === null || _a === void 0 ? void 0 : _a.some(function (e) { return e.id === firstSelectedId; }))
                    return section.id;
                if (section.children) {
                    var found = findSection(section.children);
                    if (found)
                        return found;
                }
            }
            return null;
        };
        return findSection(localSections);
    }, [selectedEntries, localSections]);
    // The section the rename/remove menu operates on:
    //   1. If the user has an entry checked, use that entry's parent section.
    //   2. Otherwise fall back to the most-recently expanded ("open") section.
    // This way the user can rename a section just by expanding it, without
    // having to check one of its entries first.
    var activeSectionId = useMemo(function () {
        if (selectedSectionId)
            return selectedSectionId;
        var ids = Array.from(expandedSectionIds);
        return ids.length > 0 ? ids[ids.length - 1] : null;
    }, [selectedSectionId, expandedSectionIds]);
    // Rename / Remove are disabled when no section is open OR when the active
    // section is the read-only "ungrouped" group from the server.
    var sectionEditDisabled = !activeSectionId || activeSectionId === 'ungrouped';
    // Flattened list of move-to targets: every section except the synthetic
    // favourites pseudo-section and the source the entries currently live in
    // (no point moving an entry into the section it already belongs to).
    var moveToTargets = useMemo(function () {
        var out = [];
        var walk = function (sections, depth) {
            for (var _i = 0, sections_7 = sections; _i < sections_7.length; _i++) {
                var section = sections_7[_i];
                if (section.id !== 'favourites' && section.id !== selectedSectionId) {
                    var title = section.titleKey.startsWith('text.')
                        ? t(section.titleKey)
                        : section.titleKey;
                    out.push({ id: section.id, title: title, depth: depth });
                }
                if (section.children)
                    walk(section.children, depth + 1);
            }
        };
        walk(localSections, 0);
        return out;
    }, [localSections, selectedSectionId]);
    var handleToggleExpand = useCallback(function (sectionId) {
        setExpandedSectionIds(function (prev) {
            var next = new Set(prev);
            if (next.has(sectionId)) {
                next.delete(sectionId);
            }
            else {
                next.add(sectionId);
            }
            saveExpandedSectionIds(next);
            return next;
        });
    }, []);
    // Close settings popup when clicking outside
    useEffect(function () {
        if (!showSettings)
            return;
        var handleClickOutside = function (e) {
            if (settingsRef.current && !settingsRef.current.contains(e.target)) {
                setShowSettings(false);
            }
        };
        document.addEventListener('pointerdown', handleClickOutside);
        return function () { return document.removeEventListener('pointerdown', handleClickOutside); };
    }, [showSettings]);
    // Add Folder UX: clicking the footer button reveals an input row pinned
    // just above the footer. The folder is only created once the user
    // confirms (Enter / blur with non-empty value); Escape or empty blur
    // cancels.
    var handleAddFolder = useCallback(function () {
        setNewFolderName('');
        setAddingFolder(true);
    }, []);
    var cancelAddFolder = useCallback(function () {
        setAddingFolder(false);
        setNewFolderName('');
    }, []);
    // Generate a fresh share code for a logged-out user and persist the
    // current state under it (no label). After it succeeds, the guest panel
    // swaps to a "Copy Code / Display Code" view powered by the returned code.
    var handleGuestGenerateCode = useCallback(function () { return __awaiter(void 0, void 0, void 0, function () {
        var _a;
        return __generator(this, function (_b) {
            switch (_b.label) {
                case 0:
                    if (guestGenerating)
                        return [2 /*return*/];
                    setGuestGenerating(true);
                    _b.label = 1;
                case 1:
                    _b.trys.push([1, 3, 4, 5]);
                    return [4 /*yield*/, withBusy(function () { return __awaiter(void 0, void 0, void 0, function () {
                            var res, body, code, rawJson, hyphenated;
                            var _a, _b, _c, _d, _e, _f, _g, _h, _j, _k;
                            return __generator(this, function (_l) {
                                switch (_l.label) {
                                    case 0: return [4 /*yield*/, fetch("".concat(API_BASE_URL, "share-codes/generate"), {
                                            method: 'POST',
                                            credentials: 'include',
                                            headers: { 'Content-Type': 'application/json' },
                                        })];
                                    case 1:
                                        res = _l.sent();
                                        if (!res.ok) {
                                            setGuestCodeGenFeedback({ ok: false });
                                            return [2 /*return*/];
                                        }
                                        return [4 /*yield*/, res.json().catch(function () { return null; })];
                                    case 2:
                                        body = _l.sent();
                                        code = (_f = (_e = (_c = (_b = (_a = body === null || body === void 0 ? void 0 : body.data) === null || _a === void 0 ? void 0 : _a.shareCode) !== null && _b !== void 0 ? _b : body === null || body === void 0 ? void 0 : body.shareCode) !== null && _c !== void 0 ? _c : (_d = body === null || body === void 0 ? void 0 : body.data) === null || _d === void 0 ? void 0 : _d.code) !== null && _e !== void 0 ? _e : body === null || body === void 0 ? void 0 : body.code) !== null && _f !== void 0 ? _f : '';
                                        if (!code) {
                                            setGuestCodeGenFeedback({ ok: false });
                                            return [2 /*return*/];
                                        }
                                        rawJson = extractUserSaveState(buildMergedPageData(), productionBaseline !== null && productionBaseline !== void 0 ? productionBaseline : null, {
                                            username: username !== null && username !== void 0 ? username : '',
                                            activityUUID: (_j = (_h = (_g = productionBaseline === null || productionBaseline === void 0 ? void 0 : productionBaseline.meta) === null || _g === void 0 ? void 0 : _g.activityUUID) !== null && _h !== void 0 ? _h : activityMeta === null || activityMeta === void 0 ? void 0 : activityMeta.activityId) !== null && _j !== void 0 ? _j : '',
                                        }, manipulativeBtnState, playerBgPattern);
                                        if (isIDM || isSwp) {
                                            rawJson.meta = __assign(__assign({}, ((_k = rawJson.meta) !== null && _k !== void 0 ? _k : {})), { url: window.location.pathname });
                                        }
                                        return [4 /*yield*/, postShareCodeSave({ sharecode: code, label: '', raw_json: rawJson }).catch(function () { return undefined; })];
                                    case 3:
                                        _l.sent();
                                        // Guest (logged-out) save — always unlabeled.
                                        trackEvent(AnalyticsCategory.save, 'save', 'guest-unlabeled');
                                        setGuestGeneratedCode(code);
                                        setGuestCodeGenFeedback({ ok: true });
                                        hyphenated = formatShareCode(code);
                                        rememberOwnShareCode(hyphenated);
                                        setShareCode(hyphenated);
                                        // Keep the activity path; only swap the share-code query string. A
                                        // bare `?abc` would rely on relative-URL resolution which can drop
                                        // the IDM path under some routing setups.
                                        window.history.replaceState(null, '', "".concat(window.location.pathname, "?").concat(hyphenated).concat(window.location.hash));
                                        return [2 /*return*/];
                                }
                            });
                        }); })];
                case 2:
                    _b.sent();
                    return [3 /*break*/, 5];
                case 3:
                    _a = _b.sent();
                    setGuestCodeGenFeedback({ ok: false });
                    return [3 /*break*/, 5];
                case 4:
                    setGuestGenerating(false);
                    return [7 /*endfinally*/];
                case 5: return [2 /*return*/];
            }
        });
    }); }, [
        guestGenerating,
        productionBaseline,
        buildMergedPageData,
        username,
        activityMeta,
        isIDM,
        setShareCode,
        playerBgPattern,
    ]);
    // Save current state against the active share code in-place (no popup form,
    // no new code generation). The InputWithBtn caller is informed via onSave so
    // upstream UI can refresh; an informational modal confirms the update.
    var handleSave = useCallback(function () { return __awaiter(void 0, void 0, void 0, function () {
        var rawJson, hyphenated, existingLabel, _a;
        var _b, _c, _d, _e, _f, _g;
        return __generator(this, function (_h) {
            switch (_h.label) {
                case 0:
                    if (isSaving || !shareCode)
                        return [2 /*return*/];
                    setIsSaving(true);
                    rawJson = extractUserSaveState(buildMergedPageData(), productionBaseline !== null && productionBaseline !== void 0 ? productionBaseline : null, {
                        username: username !== null && username !== void 0 ? username : '',
                        activityUUID: (_d = (_c = (_b = productionBaseline === null || productionBaseline === void 0 ? void 0 : productionBaseline.meta) === null || _b === void 0 ? void 0 : _b.activityUUID) !== null && _c !== void 0 ? _c : activityMeta === null || activityMeta === void 0 ? void 0 : activityMeta.activityId) !== null && _d !== void 0 ? _d : '',
                    }, manipulativeBtnState, playerBgPattern);
                    if (isIDM || isSwp) {
                        rawJson.meta = __assign(__assign({}, ((_e = rawJson.meta) !== null && _e !== void 0 ? _e : {})), { url: window.location.pathname });
                    }
                    hyphenated = formatShareCode(shareCode);
                    existingLabel = (_g = (_f = findEntryByCode(localSections, hyphenated)) === null || _f === void 0 ? void 0 : _f.label) !== null && _g !== void 0 ? _g : '';
                    _h.label = 1;
                case 1:
                    _h.trys.push([1, 3, 4, 5]);
                    return [4 /*yield*/, withBusy(function () { return __awaiter(void 0, void 0, void 0, function () {
                            var res;
                            return __generator(this, function (_a) {
                                switch (_a.label) {
                                    case 0: return [4 /*yield*/, postShareCodeSave({
                                            sharecode: hyphenated,
                                            label: existingLabel,
                                            raw_json: rawJson,
                                        })];
                                    case 1:
                                        res = _a.sent();
                                        if (!res.ok) {
                                            setShowSaveErrorModal(true);
                                            return [2 /*return*/];
                                        }
                                        rememberOwnShareCode(hyphenated);
                                        // In-place re-save against the active share code, preserving its label.
                                        trackEvent(AnalyticsCategory.save, 'resave', existingLabel ? 'labeled' : 'unlabeled');
                                        return [4 /*yield*/, fetchGroups()];
                                    case 2:
                                        _a.sent();
                                        setShowSaveInfoModal(true);
                                        onSave === null || onSave === void 0 ? void 0 : onSave();
                                        return [2 /*return*/];
                                }
                            });
                        }); })];
                case 2:
                    _h.sent();
                    return [3 /*break*/, 5];
                case 3:
                    _a = _h.sent();
                    setShowSaveErrorModal(true);
                    return [3 /*break*/, 5];
                case 4:
                    setIsSaving(false);
                    return [7 /*endfinally*/];
                case 5: return [2 /*return*/];
            }
        });
    }); }, [
        isSaving,
        shareCode,
        productionBaseline,
        buildMergedPageData,
        username,
        activityMeta,
        isIDM,
        fetchGroups,
        onSave,
        localSections,
        playerBgPattern,
    ]);
    var confirmAddFolder = useCallback(function () {
        var trimmed = newFolderName.trim();
        if (!trimmed) {
            cancelAddFolder();
            return;
        }
        // Server is source of truth: POST /groups, then re-fetch groups so the
        // new folder appears with whatever id the backend assigned.
        setAddingFolder(false);
        setNewFolderName('');
        withBusy(function () { return __awaiter(void 0, void 0, void 0, function () {
            var res;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0: return [4 /*yield*/, fetch("".concat(API_BASE_URL, "groups"), {
                            method: 'POST',
                            credentials: 'include',
                            headers: { 'Content-Type': 'application/json' },
                            body: JSON.stringify({ name: trimmed }),
                        }).catch(function () { return null; })];
                    case 1:
                        res = _a.sent();
                        if (!(res === null || res === void 0 ? void 0 : res.ok)) {
                            setShowApiErrorModal(true);
                            return [2 /*return*/];
                        }
                        return [4 /*yield*/, fetchGroups()];
                    case 2:
                        _a.sent();
                        return [2 /*return*/];
                }
            });
        }); });
    }, [newFolderName, cancelAddFolder, fetchGroups]);
    useEffect(function () {
        if (addingFolder && newFolderInputRef.current) {
            newFolderInputRef.current.focus();
        }
    }, [addingFolder]);
    // Logged-out users get a stripped-down panel with just the two
    // image-export actions plus a "Generate Code" path. Save / Duplicate /
    // Share / folders / footer all require an authenticated session.
    if (!isLoggedIn) {
        var guestHasCode = !!shareCode || !!guestGeneratedCode;
        var guestCode_1 = guestGeneratedCode || shareCode || '';
        return (_jsxs("div", { ref: guestPanelRef, className: "iwb-panel iwb-panel--guest", style: style, role: "dialog", "aria-modal": "true", "aria-label": t('text.shareYourWork'), children: [_jsx("div", { className: "iwb-arrow ".concat(arrowPosition), "aria-hidden": "true" }), _jsxs("div", { className: "iwb-actions", children: [_jsx(ButtonComponent, { defaultCSS: "iwb-actionBtn", imgSrc: {
                                normal: getImageSrc('./assets/images/shareAnImage.svg'),
                                hover: getImageSrc('./assets/images/shareAnImage.svg'),
                                disable: getImageSrc('./assets/images/shareAnImage.svg'),
                            }, imgWidth: ICON_SIZE, imgHeight: ICON_SIZE, clickHandler: function () {
                                var handler = function (data) {
                                    customEventHandler.removeEventListener('screenshotCopied', handler);
                                    setGuestImageFeedback({ ok: !!(data === null || data === void 0 ? void 0 : data.ok), reason: data === null || data === void 0 ? void 0 : data.reason, info: data === null || data === void 0 ? void 0 : data.info });
                                };
                                customEventHandler.addEventListener('screenshotCopied', handler);
                                customEventHandler.dispatchEvent('headerClicked', { id: 'downloadSS' });
                            }, ariaLabel: t('text.downloadAnImage'), type: "imageType1", noAudio: true, children: _jsx("span", { children: t('text.downloadAnImage') }) }), _jsx(ButtonComponent, { defaultCSS: "iwb-actionBtn", imgSrc: (_a = btnConfig.iwbDuplicate) === null || _a === void 0 ? void 0 : _a.imgSrc, imgWidth: ICON_SIZE, imgHeight: ICON_SIZE, clickHandler: function () {
                                var handler = function (data) {
                                    customEventHandler.removeEventListener('screenshotCopied', handler);
                                    setGuestImageFeedback({ ok: !!(data === null || data === void 0 ? void 0 : data.ok), reason: data === null || data === void 0 ? void 0 : data.reason, info: data === null || data === void 0 ? void 0 : data.info });
                                };
                                customEventHandler.addEventListener('screenshotCopied', handler);
                                customEventHandler.dispatchEvent('headerClicked', { id: 'copySS' });
                            }, ariaLabel: t('text.copyImage'), type: "imageType1", noAudio: true, children: _jsx("span", { children: t('text.copyImage') }) }), !guestHasCode && (_jsx(ButtonComponent, { defaultCSS: "iwb-actionBtn", imgSrc: (_b = btnConfig.iwbDuplicate) === null || _b === void 0 ? void 0 : _b.imgSrc, imgWidth: ICON_SIZE, imgHeight: ICON_SIZE, clickHandler: handleGuestGenerateCode, ariaLabel: t('text.generateCode'), disabled: guestGenerating, type: "textType1", noAudio: true, children: _jsx("span", { children: guestGenerating ? t('text.generating') : t('text.generateCode') }) })), guestHasCode && (_jsxs(_Fragment, { children: [_jsx(ButtonComponent, { defaultCSS: "iwb-actionBtn", clickHandler: function () { return __awaiter(void 0, void 0, void 0, function () {
                                        var ok;
                                        return __generator(this, function (_a) {
                                            switch (_a.label) {
                                                case 0: return [4 /*yield*/, copyTextToClipboard(formatShareCode(guestCode_1))];
                                                case 1:
                                                    ok = _a.sent();
                                                    setGuestCopyFeedback({ ok: ok });
                                                    return [2 /*return*/];
                                            }
                                        });
                                    }); }, ariaLabel: t('text.copyCode'), type: "textType1", noAudio: true, children: _jsx("span", { children: t('text.copyCode') }) }), _jsx(ButtonComponent, { defaultCSS: "iwb-actionBtn", imgSrc: {
                                        normal: getImageSrc('./assets/images/icons/labelViewCode.svg'),
                                        hover: getImageSrc('./assets/images/icons/labelViewCode.svg'),
                                        disable: getImageSrc('./assets/images/icons/labelViewCode.svg'),
                                    }, imgWidth: ICON_SIZE, imgHeight: ICON_SIZE, clickHandler: function () { return setGuestShowDisplayCode(true); }, ariaLabel: t('text.displayCode'), type: "imageType1", noAudio: true, children: _jsx("span", { children: t('text.displayCode') }) }), _jsx(ButtonComponent, { defaultCSS: "iwb-actionBtn", imgSrc: (_c = btnConfig.iwbDuplicate) === null || _c === void 0 ? void 0 : _c.imgSrc, imgWidth: ICON_SIZE, imgHeight: ICON_SIZE, clickHandler: handleGuestGenerateCode, ariaLabel: t('text.generateNewCode'), disabled: guestGenerating, type: "textType1", noAudio: true, children: _jsx("span", { children: guestGenerating ? t('text.generating') : t('text.generateNewCode') }) })] }))] }), _jsx(ViewCodeModal, { showModal: guestShowDisplayCode, setShowModal: function (show) { return setGuestShowDisplayCode(show); }, code: guestCode_1 }), guestCopyFeedback && (_jsx(Popup, { isOpen: true, onClose: function () { return setGuestCopyFeedback(null); }, ariaLabel: guestCopyFeedback.ok ? t('text.codeCopied') : t('text.copyFailed'), children: _jsxs("div", { className: "iwb-saveInfoModal", role: "dialog", children: [_jsx("p", { className: "iwb-saveInfoMsg", children: guestCopyFeedback.ok ? t('text.codeCopied') : t('text.copyFailed') }), _jsx(ButtonComponent, { type: "textType1", text: t('text.ok'), defaultCSS: "iwb-saveInfoOkBtn", normalCSS: "iwb-saveInfoOkBtn", clickHandler: function () { return setGuestCopyFeedback(null); }, ariaLabel: "text.ok" })] }) })), guestImageFeedback && (_jsx(Popup, { isOpen: true, onClose: function () { return setGuestImageFeedback(null); }, ariaLabel: guestImageFeedback.ok
                        ? ((_d = guestImageFeedback.info) === null || _d === void 0 ? void 0 : _d.mode) === 'download'
                            ? t('text.imageDownloaded')
                            : t('text.imageCopied')
                        : guestImageFeedback.reason === 'insecure'
                            ? t('text.copyNeedsSecure')
                            : t('text.copyFailed'), children: _jsxs("div", { className: "iwb-saveInfoModal", role: "dialog", children: [_jsx("p", { className: "iwb-saveInfoMsg", children: guestImageFeedback.ok
                                    ? ((_e = guestImageFeedback.info) === null || _e === void 0 ? void 0 : _e.mode) === 'download'
                                        ? t('text.imageDownloaded')
                                        : t('text.imageCopied')
                                    : guestImageFeedback.reason === 'insecure'
                                        ? t('text.copyNeedsSecure')
                                        : t('text.copyFailed') }), _jsx(ButtonComponent, { type: "textType1", text: t('text.ok'), defaultCSS: "iwb-saveInfoOkBtn", normalCSS: "iwb-saveInfoOkBtn", clickHandler: function () { return setGuestImageFeedback(null); }, ariaLabel: "text.ok" })] }) })), guestCodeGenFeedback && (_jsx(Popup, { isOpen: true, onClose: function () { return setGuestCodeGenFeedback(null); }, ariaLabel: guestCodeGenFeedback.ok ? t('text.codeGenerated') : t('text.codeGenerateFailed'), children: _jsxs("div", { className: "iwb-saveInfoModal", role: "dialog", children: [_jsx("p", { className: "iwb-saveInfoMsg", children: guestCodeGenFeedback.ok ? t('text.codeGenerated') : t('text.codeGenerateFailed') }), _jsx(ButtonComponent, { type: "textType1", text: t('text.ok'), defaultCSS: "iwb-saveInfoOkBtn", normalCSS: "iwb-saveInfoOkBtn", clickHandler: function () { return setGuestCodeGenFeedback(null); }, ariaLabel: "text.ok" })] }) }))] }));
    }
    return (_jsxs("div", { className: "iwb-panel", style: style, role: "dialog", "aria-modal": "false", "aria-label": t('text.save'), children: [_jsx("div", { className: "iwb-arrow ".concat(arrowPosition), "aria-hidden": "true" }), _jsxs("div", { className: "iwb-actions", children: [_jsx(ButtonComponent, { defaultCSS: "iwb-actionBtn", imgSrc: (_f = btnConfig.iwbSave) === null || _f === void 0 ? void 0 : _f.imgSrc, imgWidth: ICON_SIZE, imgHeight: ICON_SIZE, clickHandler: function () {
                            var _a;
                            // Cases:
                            //   1. Existing share code with a label → in-place re-save.
                            //   1b. Existing share code that's still unlabeled, and the user is
                            //       a logged-in admin/owner → open the modal titled "Save this
                            //       Activity" so they name it, saving in place under the same
                            //       code (a freshly-created empty code has no label yet).
                            //   2. No share code, non-IDM/SWP activity → open the duplicate modal
                            //      retitled "Save this Activity" so the user names the first
                            //      save (this becomes the new active share code).
                            //   3. No share code, SWP (shareable) → open the duplicate modal.
                            //   4. No share code, IDM (not shareable) → button is disabled.
                            if (hasShareCode) {
                                var existingLabel = (_a = findEntryByCode(localSections, formatShareCode(shareCode))) === null || _a === void 0 ? void 0 : _a.label;
                                var labelIsBlank = !existingLabel || !existingLabel.trim();
                                if (isLoggedIn && isAdmin && labelIsBlank) {
                                    setSaveExistingUnlabeled(true);
                                    setShowDuplicateModal(true);
                                    return;
                                }
                                handleSave();
                                return;
                            }
                            if (!isIDM || isSwp) {
                                setSaveAsNewActivity(true);
                                setShowDuplicateModal(true);
                            }
                        }, disabled: isSaving || (isIDM && !isSwp && !hasShareCode) || !isAdmin, ariaLabel: "text.save", type: "imageType1", noAudio: true, children: _jsx("span", { children: t('text.save') }) }), _jsx(ButtonComponent, { defaultCSS: "iwb-actionBtn", imgSrc: (_g = btnConfig.iwbDuplicate) === null || _g === void 0 ? void 0 : _g.imgSrc, imgWidth: ICON_SIZE, imgHeight: ICON_SIZE, clickHandler: function () {
                            setShowDuplicateModal(true);
                            if (hasSelection)
                                handleDuplicateEntries();
                        }, ariaLabel: "text.saveAs", type: "imageType1", noAudio: true, children: _jsx("span", { children: t('text.saveAs') }) }), _jsx(ButtonComponent, { defaultCSS: "iwb-actionBtn", imgSrc: (_h = btnConfig.iwbShare) === null || _h === void 0 ? void 0 : _h.imgSrc, imgWidth: ICON_SIZE, imgHeight: ICON_SIZE, clickHandler: function () {
                            setShowIwbSharePopup(true);
                            onShare === null || onShare === void 0 ? void 0 : onShare();
                        }, disabled: !hasShareCode || pdfExists, ariaLabel: "text.share", type: "imageType1", noAudio: true, children: _jsx("span", { children: t('text.share') }) })] }), _jsx(CustomScrollbar, { direction: "vertical", className: "iwb-body", children: sectionsWithFavourites.map(function (section, idx) { return (_jsxs(React.Fragment, { children: [idx > 0 && _jsx("div", { className: "iwb-sectionDivider" }), _jsx(CollapsibleSection, { section: section, depth: 0, selectedSet: selectedEntries, onCheckToggle: handleCheckToggle, onRenameSection: handleRenameSection, onRemoveSection: handleRemoveSection, onSortByModified: handleSortByModified, onSortByName: handleSortByName, onToggleFavourite: handleToggleFavourite, isExpanded: expandedSectionIds.has(section.id), onToggleExpand: handleToggleExpand })] }, section.id)); }) }), renameModal && (_jsx("div", { className: "iwb-renameRow", children: _jsx("input", { ref: renameInputRef, type: "text", className: "iwb-renameInput", value: renameValue, "aria-label": t('text.enterNewName'), onChange: function (e) { return setRenameValue(e.target.value); }, onKeyDown: function (e) {
                        if (e.key === 'Enter') {
                            e.preventDefault();
                            confirmRename();
                        }
                        else if (e.key === 'Escape') {
                            e.preventDefault();
                            setRenameModal(null);
                            setRenameValue('');
                        }
                    }, onBlur: function () {
                        if (renameValue.trim()) {
                            confirmRename();
                        }
                        else {
                            setRenameModal(null);
                            setRenameValue('');
                        }
                    } }) })), addingFolder && (_jsx("div", { className: "iwb-newFolderRow", children: _jsx("input", { ref: newFolderInputRef, type: "text", className: "iwb-newFolderInput", value: newFolderName, placeholder: t('text.newFolderName'), "aria-label": t('text.newFolderName'), onChange: function (e) { return setNewFolderName(e.target.value); }, onKeyDown: function (e) {
                        if (e.key === 'Enter') {
                            e.preventDefault();
                            confirmAddFolder();
                        }
                        else if (e.key === 'Escape') {
                            e.preventDefault();
                            cancelAddFolder();
                        }
                    }, onBlur: function () {
                        if (newFolderName.trim()) {
                            confirmAddFolder();
                        }
                        else {
                            cancelAddFolder();
                        }
                    } }) })), _jsxs("div", { className: "iwb-footer", role: "toolbar", "aria-label": t('text.actions'), children: [_jsx(ButtonComponent, { defaultCSS: "iwb-footerBtn", imgSrc: (_j = btnConfig.iwbDelete) === null || _j === void 0 ? void 0 : _j.imgSrc, clickHandler: handleDeleteEntries, disabled: !hasSelection, ariaLabel: "text.delete", type: "imageType1", noAudio: true }), _jsx(ButtonComponent, { defaultCSS: "iwb-footerBtn", imgSrc: (_k = btnConfig.iwbAddFolder) === null || _k === void 0 ? void 0 : _k.imgSrc, clickHandler: handleAddFolder, ariaLabel: "text.addFolder", title: "text.addFolder", showToolTip: true, direction: "top", type: "imageType1", noAudio: true }), _jsx("hr", { className: "iwb-footerDivider", "aria-hidden": "true" }), _jsxs("div", { className: "iwb-settingsWrapper", ref: settingsRef, children: [_jsx(ButtonComponent, { defaultCSS: "iwb-footerBtn iwb-settingsBtn", text: "\u22EE", clickHandler: function () { return setShowSettings(function (prev) { return !prev; }); }, ariaLabel: "text.settings", title: "text.settings", showToolTip: true, direction: "top", type: "imageType1", noAudio: true, normalCSS: "iwb_3dotsBtn" }), showSettings && (_jsxs("div", { className: "iwb-settingsPopup", children: [_jsx(ButtonComponent, { defaultCSS: "iwb-settingsItem", text: t('text.sortByName'), clickHandler: function () {
                                            handleSortByName();
                                            setShowSettings(false);
                                        }, noAudio: true }), _jsx(ButtonComponent, { defaultCSS: "iwb-settingsItem", text: t('text.sortByMostRecent'), clickHandler: function () {
                                            handleSortByModified();
                                            setShowSettings(false);
                                        }, noAudio: true }), _jsx(ButtonComponent, { defaultCSS: "iwb-settingsItem", text: t('text.displayCode'), clickHandler: function () {
                                            setShowDisplayCodeModal(true);
                                            setShowSettings(false);
                                        }, disabled: !hasShareCode, noAudio: true }), _jsx(ButtonComponent, { defaultCSS: "iwb-settingsItem", text: t('text.moveTo'), clickHandler: function () {
                                            setShowMoveToModal(true);
                                            setShowSettings(false);
                                        }, disabled: !hasSelection, noAudio: true })] }))] })] }), showMoveToModal && (_jsx(Popup, { isOpen: showMoveToModal, onClose: function () { return setShowMoveToModal(false); }, ariaLabel: t('text.moveTo'), children: _jsxs("div", { className: "iwb-moveToPopup", role: "dialog", children: [_jsx("h2", { className: "iwb-moveToPopup__title", children: t('text.moveTo') }), _jsx("hr", { className: "popupHr", "aria-hidden": "true" }), moveToTargets.length === 0 ? (_jsx("div", { className: "iwb-moveToPopup__empty", children: t('text.noFoldersAvailable') })) : (_jsx("ul", { className: "iwb-moveToPopup__list", children: moveToTargets.map(function (target) { return (_jsx("li", { style: { paddingLeft: "".concat(target.depth * 16, "px") }, children: _jsx(ButtonComponent, { defaultCSS: "iwb-moveToPopup__item", text: target.title, clickHandler: function () { return handleMoveTo(target.id); }, noAudio: true }) }, target.id)); }) }))] }) })), showSaveInfoModal && (_jsx(Popup, { isOpen: showSaveInfoModal, onClose: function () { return setShowSaveInfoModal(false); }, ariaLabel: t('text.shareCodeUpdated'), children: _jsxs("div", { className: "iwb-saveInfoModal", role: "dialog", children: [_jsx("p", { className: "iwb-saveInfoMsg", children: t('text.shareCodeUpdatedMsg') }), _jsx(ButtonComponent, { type: "textType1", text: t('text.ok'), defaultCSS: "iwb-saveInfoOkBtn", normalCSS: "iwb-saveInfoOkBtn", clickHandler: function () { return setShowSaveInfoModal(false); }, ariaLabel: "text.ok" })] }) })), showSaveErrorModal && (_jsx(Popup, { isOpen: showSaveErrorModal, onClose: function () { return setShowSaveErrorModal(false); }, ariaLabel: t('text.saveFailedTitle'), children: _jsxs("div", { className: "iwb-saveInfoModal", role: "dialog", children: [_jsx("p", { className: "iwb-saveInfoMsg", children: t('text.saveFailedMsg') }), _jsx(ButtonComponent, { type: "textType1", text: t('text.ok'), defaultCSS: "iwb-saveInfoOkBtn", normalCSS: "iwb-saveInfoOkBtn", clickHandler: function () { return setShowSaveErrorModal(false); }, ariaLabel: "text.ok" })] }) })), _jsx(SaveWorkModal, { showModal: showDuplicateModal, setShowModal: function (value) {
                    // value can be a boolean or an updater fn; resolve before resetting.
                    var next = typeof value === 'function' ? value(showDuplicateModal) : value;
                    setShowDuplicateModal(next);
                    if (!next) {
                        setSaveAsNewActivity(false);
                        setSaveExistingUnlabeled(false);
                    }
                }, 
                // Naming an existing unlabeled code: keep that code, don't generate a
                // new one, and title the popup "Save this Activity".
                code: saveExistingUnlabeled ? formatShareCode(shareCode) : '', regenerateCode: !saveExistingUnlabeled, 
                // "Save As" (duplicate) only — a brand-new code that is neither the
                // first save of an activity (saveAsNewActivity) nor naming an existing
                // unlabeled code. The duplicate is the original activity + only the
                // user's annotations; the other save flows keep saving everything.
                annotationsOnly: !saveAsNewActivity && !saveExistingUnlabeled, title: saveExistingUnlabeled
                    ? t('text.saveThisActivity')
                    : saveAsNewActivity
                        ? t('text.saveYourWork')
                        : t('text.duplicateActivityTitle'), subtitle: t('text.duplicateActivitySubtitle') }), _jsx(ViewCodeModal, { showModal: showDisplayCodeModal, setShowModal: function (show) { return setShowDisplayCodeModal(show); }, code: shareCode !== null && shareCode !== void 0 ? shareCode : '' }), showDeleteConfirm && (_jsx(Popup, { isOpen: true, onClose: function () { return setShowDeleteConfirm(false); }, className: "className-eraserPopup", children: _jsx("div", { className: "eraserWrapper", children: _jsxs("div", { className: "container", children: [_jsxs("div", { className: "upperPart", children: [_jsx("div", { className: "title", children: t('text.deleteShareCodesConfirm') }), _jsx("hr", { className: "popupHr", "aria-hidden": "true" }), _jsxs("div", { className: "btnContainer", children: [_jsx(ButtonComponent, { type: "textType1", text: t('text.cancel'), defaultCSS: "customBtn", normalCSS: "btn", clickHandler: function () { return setShowDeleteConfirm(false); }, noAudio: true }), _jsx(ButtonComponent, { type: "textType1", text: t('text.delete'), defaultCSS: "customBtn", normalCSS: "btn", clickHandler: confirmDeleteEntries, noAudio: true })] })] }), _jsx("div", { className: "footerImageHolder", style: { backgroundImage: 'url(./assets/images/shareColourPatches.svg)' } })] }) }) })), showDeleteSuccess && (_jsx(Popup, { isOpen: true, onClose: function () {
                    setShowDeleteSuccess(false);
                    // If the active share code was deleted, redirect to root now
                    // that the user has acknowledged the success message.
                    if (window.__iwbDeleteRedirect) {
                        window.__iwbDeleteRedirect = false;
                        window.location.href = '/';
                    }
                }, ariaLabel: t('text.deletedSuccessfully'), children: _jsxs("div", { className: "iwb-saveInfoModal", role: "dialog", children: [_jsx("p", { className: "iwb-saveInfoMsg", children: t('text.deletedSuccessfully') }), _jsx(ButtonComponent, { type: "textType1", text: t('text.ok'), defaultCSS: "iwb-saveInfoOkBtn", normalCSS: "iwb-saveInfoOkBtn", clickHandler: function () {
                                setShowDeleteSuccess(false);
                                if (window.__iwbDeleteRedirect) {
                                    window.__iwbDeleteRedirect = false;
                                    window.location.href = '/';
                                }
                            }, ariaLabel: "text.ok" })] }) })), showApiErrorModal && (_jsx(Popup, { isOpen: showApiErrorModal, onClose: function () { return setShowApiErrorModal(false); }, ariaLabel: t('text.actionFailedTitle'), children: _jsxs("div", { className: "iwb-saveInfoModal", role: "dialog", children: [_jsx("p", { className: "iwb-saveInfoMsg", children: t('text.actionFailedMsg') }), _jsx(ButtonComponent, { type: "textType1", text: t('text.ok'), defaultCSS: "iwb-saveInfoOkBtn", normalCSS: "iwb-saveInfoOkBtn", clickHandler: function () { return setShowApiErrorModal(false); }, ariaLabel: "text.ok" })] }) })), removeSectionId && (_jsx(Popup, { isOpen: true, onClose: function () { return setRemoveSectionId(null); }, className: "className-eraserPopup", children: _jsx("div", { className: "eraserWrapper", children: _jsxs("div", { className: "container", children: [_jsxs("div", { className: "upperPart", children: [_jsx("div", { className: "title", children: t('text.removeSectionConfirm') }), _jsx("hr", { className: "popupHr", "aria-hidden": "true" }), _jsxs("div", { className: "btnContainer", children: [_jsx(ButtonComponent, { type: "textType1", text: t('text.cancel'), defaultCSS: "customBtn", normalCSS: "btn", clickHandler: function () { return setRemoveSectionId(null); }, noAudio: true }), _jsx(ButtonComponent, { type: "textType1", text: t('text.delete'), defaultCSS: "customBtn", normalCSS: "btn", clickHandler: confirmRemoveSection, noAudio: true })] })] }), _jsx("div", { className: "footerImageHolder", style: { backgroundImage: 'url(./assets/images/shareColourPatches.svg)' } })] }) }) }))] }));
};
export default InputWithBtn;
